export default __webpack_public_path__ + "static/media/Group 82.b4122757.png";